module.exports = __webpack_public_path__ + "img/img345.16a5da2d.svg";